import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/imdb': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M350.5 288.7C350.5 294.1 352.1 303.1 344.3 303.1 342.7 303.1 341.3 302.3 340.5 300.7 338.3 295.6 339.4 256.6 339.4 256 339.4 252.2 338.3 243.3 344.3 243.3 351.6 243.3 350.5 250.6 350.5 256V288.7zM265 229.9C265 220.2 266.6 213.9 254.7 213.9V297.6C266.9 297.9 265 288.9 265 279.2V229.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM21.3 228.8C21.2 228.9 21.1 229.1 21 229.2H21.3V228.8zM97 192H64V319.8H97V192zM210.3 192H167.2L159.6 251.9C156.9 231.9 154.2 211.8 150.9 192H108.1V319.8H137.1V235.3L149.3 319.8H169.9L181.5 233.4V319.8H210.2V192zM296.6 237.3C296.6 229.2 296.9 220.5 295.2 212.9 290.9 190.4 263.8 192 246.2 192H221.6V319.8C307.7 319.9 296.6 325.8 296.6 237.3zM382.5 254.6C382.5 237.3 381.7 224.5 360.3 224.5 351.4 224.5 345.4 227.2 339.4 233.7V192H307.7V319.8H337.5L339.4 311.7C345.1 318.5 351.3 321.5 360.3 321.5 380.1 321.5 382.5 306.3 382.5 290.6V254.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/imdb.js
// module id = vztw
// module chunks = 144